// src/components/ui/Input.tsx
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
  icon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({ label, error, helpText, icon, className = '', ...props }) => {
  return (
    <div className="space-y-1.5">
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">
          {label}
          {props.required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-neutral-text-secondary">
            {icon}
          </div>
        )}
        <input
          className={`
            w-full rounded-lg border border-neutral-border px-4 py-2.5 text-sm
            placeholder:text-neutral-text-secondary
            focus:outline-none focus:ring-2 focus:ring-teal-light focus:border-teal-light
            disabled:bg-neutral-bg disabled:cursor-not-allowed
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-danger focus:ring-danger' : ''}
            ${className}
          `}
          {...props}
        />
      </div>
      {error && <p className="text-xs text-danger">{error}</p>}
      {helpText && !error && <p className="text-xs text-neutral-text-secondary">{helpText}</p>}
    </div>
  );
};

export default Input;